import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4caa44d2")

_pushScopeId("data-v-4caa44d2")
const _hoisted_1 = { class: "df-col df-center ml-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("First Deposit Bonus")
const _hoisted_3 = { class: "df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    custom: "",
    to: "/events/firstDeposit"
  }, {
    default: _withId(({ navigate }) => [
      (_ctx.isFirst)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "px-12 df-middle df-center br-lg card-wrap",
            style: {"background":"#FCE9D6"},
            onClick: navigate
          }, [
            _createVNode(_component_Pic, {
              src: "events/firstDeposit/gift",
              width: "32",
              height: "32"
            }),
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_t, {
                path: "trade_34",
                class: "f-bold",
                style: {"font-size":"12px"}
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Pic, {
                  src: "events/firstDeposit/hot",
                  width: "12",
                  height: "12"
                }),
                _createVNode(_component_t, {
                  path: "trade_35",
                  args: {number: _ctx.recipients},
                  class: "c-title",
                  style: {"font-size":"11px"}
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.recipients) + " users start up today!", 1)
                  ]),
                  _: 1
                }, 8, ["args"])
              ])
            ])
          ], 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})